var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuCorsiLista(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M842.53,0H174.49C91.59,0,28.2,68.27,28.2,146.29v731.43c0,82.9,68.27,146.29,146.29,146.29h663.16c82.9,0,146.29-68.27,146.29-146.29h4.88V146.29c0-82.9-68.27-146.29-146.29-146.29ZM467.06,551.01c-4.88,0-9.75,0-14.63-4.88l-102.4-68.27c-9.75-4.88-19.5-4.88-29.26,0l-112.15,73.14c-14.63,4.88-29.26,4.88-39.01-9.75-4.88-4.88-4.88-9.75-4.88-14.63V190.17c0-29.26,24.38-53.64,53.64-53.64h219.43c29.26,0,53.64,24.38,58.51,48.76v336.46h.01c0,14.63-14.63,29.26-29.26,29.26ZM909.18,762.56c0,31.01-25.14,56.15-56.15,56.15h-207.82c-31.01,0-56.15-25.14-56.15-56.15h0c0-31.01,25.14-56.15,56.15-56.15h207.82c31.01,0,56.15,25.14,56.15,56.15h0ZM909.18,512.01c0,31.01-25.14,56.15-56.15,56.15h-207.82c-31.01,0-56.15-25.14-56.15-56.15h0c0-31.01,25.14-56.15,56.15-56.15h207.82c31.01,0,56.15,25.14,56.15,56.15h0ZM909.18,261.45c0,31.01-25.14,56.15-56.15,56.15h-207.82c-31.01,0-56.15-25.14-56.15-56.15h0c0-31.01,25.14-56.15,56.15-56.15h207.82c31.01,0,56.15,25.14,56.15,56.15h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCorsiLista);
export default __webpack_public_path__ + "static/media/menu-corsi-lista.a500de0d28eb9df2c217f751df708c6e.svg";
export { ForwardRef as ReactComponent };